module.exports = __webpack_public_path__ + "static/media/Illus-404.e7372426.png";